import React, { useEffect } from "react";
import { AdminRecordInterface } from "src/store/watcher/adminsSlice";
import { ROLE_OPTIONS } from "src/helpers/RoleHelper";

import { Button, Form, Input, Select } from "antd";

interface propsInterface {
  params?: Partial<AdminRecordInterface> | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const isEdit = !!params?.id;

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='username' label="Username" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item name='email' label="Email" rules={[{ required: true }, { type: 'email' }]}>
        <Input />
      </Form.Item>

      <Form.Item name='role' label="Role" rules={[{ required: true }]}>
        <Select options={ROLE_OPTIONS} />
      </Form.Item>

      <Form.Item
        name='password'
        label={isEdit ? "New Password (leave blank to keep current)" : "Password"}
        rules={isEdit ? [] : [{ required: true }]}
      >
        <Input.Password autoComplete='new-password' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
